import React, { useEffect, useState } from 'react';
import { getCurrentProject } from "../../redux/actions/currentProject";
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Nav, NavItem, NavLink, TabContent, TabPane, Container, Row } from 'reactstrap';
import classnames from 'classnames';
import Main from '../../layout/main'
import ProjectSummary from './projectSummary';
import InterestedProvidersContainer from '../InterestedProviders';
const ProjectDetailPage = (props) => {
    const { project_id, id, from } = props.match.params;
    const [activeTab, setActiveTab] = useState('2');
    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getCurrentProject(id));
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [project_id, id, from])
    const projectData = useSelector(state => state.currentProjectData.projectData);
    const projectDataLoading = useSelector(state => state.currentProjectData.loading);
    return (
        <div>
            <Helmet>
                <title>EasyBids - Home Improvements :: Project Detail</title>
            </Helmet>
            <Main additionalClass_main="myprojects">
                <Nav tabs className="ebw-projects__navtab">
                    <Container>
                        <Row>
                            <NavItem className="ebw-tab__item">
                                <NavLink
                                    className={classnames({ active: activeTab === '1' })}
                                    onClick={() => { toggle('1'); }}
                                >
                                    Interested Providers
                                </NavLink>
                            </NavItem>
                            <NavItem className="ebw-tab__item">
                                <NavLink
                                    className={classnames({ active: activeTab === '2' })}
                                    onClick={() => { toggle('2'); }}
                                >
                                    Project Summary
                                </NavLink>
                            </NavItem>
                        </Row>
                    </Container>
                </Nav>
                <section className="ebw-section ebw-section__pages">
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <Container>
                                <InterestedProvidersContainer
                                    project_id={id}
                                    hiredProviderId={projectData.provider_id}
                                />
                            </Container>

                        </TabPane>

                        <TabPane tabId="2">
                            <Container>

                                {/* <>
                                    <div className="d-md-flex justify-content-between ">
                                        <div className="ebw-title__primary">Project Summary</div>
                                    </div>
                                    
                                </> */}
                                <ProjectSummary {...projectData} project_id={id} projectSummaryLoading={projectDataLoading} />
                            </Container>
                        </TabPane>
                    </TabContent>
                </section>
            </Main>
        </div>
    );
}

export default ProjectDetailPage;